"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const redux_batch_1 = require("@manaflair/redux-batch");
const detect_utils_1 = require("@/common/detect_utils");
function default_1(reducer) {
    const store = (0, toolkit_1.configureStore)({
        reducer,
        middleware: getDefaultMiddleware => {
            return getDefaultMiddleware();
        },
        devTools: detect_utils_1.isLocalhost,
        enhancers: [redux_batch_1.reduxBatch],
    });
    return store;
}
exports.default = default_1;
